import { Component } from '@angular/core';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../shared/shared-service-registry';
import { SavedSearchService } from '../../../shared/search/saved-search.service';
import { NavigationService } from '../../../core/navigation.service';
import { UserPreferenceService } from '../services/user-preference.service';
import { AlertService,ResourceService } from 'sce-core';
import { DELETE_FAVOURITE, DELETE_SEARCH, UserPreferenceEvent } from '../../../shared/models/user-favourite-event';
import { menuIdRouteMappings } from '../../../constants';

@Component({
  selector: 'lfwms-favorites',
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.css']
})
export class FavoritesComponent {

    private readonly lastClickedDocId: number;
    public expandRecentItems: boolean = false;
    public recentItemsList: Array<any> = [];    
    public savedSearchesList: Array<any> = [];    
    public favoritesList: Array<any> = [];
  
    private readonly alertservice: AlertService;
    private readonly savedSearchService: SavedSearchService;
    private readonly navService: NavigationService;
    private readonly userPreferenceService: UserPreferenceService;
    private readonly resourceService: ResourceService;
  
  
  
    constructor(private readonly coreServiceRegistry: CoreServiceRegistry,
        private readonly sharedServiceRegistry: SharedServiceRegistry) {
      this.resourceService = this.coreServiceRegistry.resourceService;    
      this.navService = this.coreServiceRegistry.navigationService; 
      this.alertservice = this.sharedServiceRegistry.alertService;    
      this.savedSearchService = this.sharedServiceRegistry.savedSearchService;
      this.userPreferenceService
        = this.sharedServiceRegistry.userPreferencesService;

        this.getFavorites();  
        this.getSavedSearches();   
        this.toggleRecentItems();
     
    }

   // Toggle recent items in sidepanel
    public toggleRecentItems() {
        this.userPreferenceService.getRecentSearchItemsList()
          .subscribe((response: any) => {
            this.recentItemsList = response.recentItems;
            this.expandRecentItems = true;
          });
    }
  
    // Toggle saved searches in sidepanel
    public getSavedSearches() {     
        this.userPreferenceService.getAllSavedSearchCriterias()
          .subscribe((response: any) => {
            this.savedSearchesList = response.searchResults;  
          });      
    }
  
   // Toggle favorites in sidepanel
   public getFavorites() {     
        this.userPreferenceService.getAllFavorites()
          .subscribe((response: any) => {
            this.favoritesList = response.favorites;           
          });      
    }
  public toggleModal () {
    const mcModal = document.body.querySelector('mc-modal');
    if (mcModal) {
      (mcModal as any).width = {
        sm: '100%',
        md: '80%',
        lg: '986px',
        xl: '986px',
      };
      (mcModal as any).height = {
        sm: '100%',
        md: '80%',
        lg: '540px',
        xl: '540px',
      };
      (mcModal as any).open = true;
    }
  };
  public goBack () {
    console.log('go back button clicked');
    this.toggleModal();
  };
    // method to delete search
    public deleteSearchCondition(searchId: number) {
      const searchIdsList: Array<any> = [searchId];
      this.savedSearchService.deleteSearchCriteria(searchIdsList)
      .subscribe((resp: any) => {
        this.handleDeleteResponse(resp, DELETE_SEARCH, searchId, () => {
        this.userPreferenceService.getAllSavedSearchCriterias()
          .subscribe((response: any) => {
          this.savedSearchesList = response.searchResults;
          });
        }, 'Search Criteria deleted Successfully');
      });
    }

    private handleDeleteResponse(
      response: any,
      eventType: number,
      itemId: number,
      onSuccess: () => void,
      successMessage: string
    ) {
      if (response['statusCode'] && response['statusMessage']) {
      if (response['statusCode'] === 200 && response['statusMessage'] === 'SUCCESS') {
        this.alertservice.clearAll().success(successMessage);
      }
      this.notifyEvent(eventType, itemId);
      onSuccess();
      } else if (response.error) {
      this.alertservice.clearAll()
        .error(this.resourceService.translateServerResponse(response.error));
      }
    }
    
    public navigateToDetailsPage(itemType: string, documentId: number, displayValue: string) {
      if (this.lastClickedDocId !== documentId) {
      itemType = itemType.toLowerCase();
      const url: string = menuIdRouteMappings[itemType] + '/details';
      this.navService.resetBreadcrumb('home');
      const routeParams = itemType === 'commodity'
        ? [documentId.toString(), displayValue.split('#').pop()]
        : [documentId.toString()];
      this.navService.navigateWithRouteParams(url, routeParams);
      }
    }
    
    public navigateToSearchPage(searchId: number, itemType: string) {
      this.navService.resetBreadcrumb('home')
      .addBreadCrumbItem(this.resourceService.get('mn_' + itemType), itemType.toLowerCase());
      this.navService.navigatetoSearch(itemType, [searchId.toString()]);
    }
    
    public navigateToFavorites(menuId: string) {
      this.navService.navigateByMenuId(menuId);
    }
    
    public getLabel(key: any) {      
      return this.resourceService.get(key);
    }

     private notifyEvent(type: number, item: number) {
        const $event: UserPreferenceEvent = new UserPreferenceEvent();
        $event.type = type;
        $event.item = '' + item;
        $event.source = 'leftmenu';
        $event.preferenceId = item;
        this.userPreferenceService.notifyEvent($event);
      }
  
    // Delete favorites from side panel
    public deletefavorites(preferenceId: number) {
      this.userPreferenceService.deleteFavorites(preferenceId)
        .subscribe((response: any) => {
          if (response['statusCode'] && response['statusMessage']) {
            this.notifyEvent(DELETE_FAVOURITE, preferenceId);
           this.alertservice.clearAll()
           .success('My favourite record deleted Successfully');
            this.userPreferenceService.getAllFavorites()
              .subscribe((data: any) => {
                this.favoritesList = data.favorites;
              });
          } else if (response.error) {
              this.alertservice.clearAll()
                .error(this.resourceService
                  .translateServerResponse(response.error));
          }
        });
    }
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/favorites/favorites.component.ts